import React from 'react';
import { ToggleWrapper } from './ToggleWrapper';
import { ToggledFeature } from './featureToggleService';

export function MarketTimezoneToggleWrapper(
  props: {
    children: React.ReactNode;
  }
) {
  return (
    <ToggleWrapper feature={ToggledFeature.MARKET_TIMEZONE}>
      {props.children}
    </ToggleWrapper>
  );
}
